import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from './../../../services/loading.service';
import { SearchSectionService } from './../../../services/searchSection.service';
import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Input } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faMapMarkerAlt, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ThemePalette } from '@angular/material/core';
import { SearchService } from 'src/app/services/search.service';
import { VehicleReservationSearchParm } from './../../../models/VehicleReservationSearchParm';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { Router } from '@angular/router';
//import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NotificationsService } from 'angular2-notifications';
import { ReservationSettingModel } from 'src/app/models/Booking/ReservationSettingModel';
import { TranslateService } from '@ngx-translate/core';
import { ResourceService } from 'src/app/services/resource.service';
import { LanguageModel } from 'src/app/models/LanguageModel';
import PlaceResult = google.maps.places.PlaceResult;
import {Location as LocationAutocomplete, Appearance, GermanAddress} from '@angular-material-extensions/google-maps-autocomplete';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';




declare var $: any;
@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class SearchComponent implements OnInit, AfterViewInit {
  direction;
  currentLocation = { lat: 0, lng: 0 };
  faChevronDown = faChevronDown;
  searchForm: FormGroup;
  submitted = false;
  faMapMarkerAlt = faMapMarkerAlt;
  faCalendarAlt = faCalendarAlt;
  easyRent = false;
  showmsg = false;
  address: PlaceResult;
  options = {
    types: []
    //componentRestrictions: {}
  };
  minPickUpDate: any;
  minDropOffDate: any;
  minTime: any;

  //Slide toggle
  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  manualUpdate: boolean;
  selectedLang: any;

  parameters: Array<string> = ["T"];

  easyRentSection = false;

  gracePeriod: number = 0;
  minDroppOffTime: string;
  customer: any;
  currentLocationFormatedAdress: any;

  constructor(private formBuilder: FormBuilder,
    protected cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private _dateFormatPipe: DateFormatPipe,
    private router: Router,
    private _notifications: NotificationsService,
    private searchSectionService: SearchSectionService,
    private loadingService: LoadingService,
    private translate: TranslateService,
    private authService: AuthService,
    private resourceService: ResourceService,
    private _adapter: DateAdapter<any>
  ) {

    //var svgValue=this.searchService.imageSvgString('hello');
    //var url=svgToUrlImage(svgValue);
    //
    //var url=this.searchService.svgToUrlImage(svgValue);

  }

  ngOnInit() {

    this.loadingService.show();
    let dateOfTmw = new Date();
    dateOfTmw.setDate(new Date().getDate() + 1);
    this.minPickUpDate = this.searchService.getFirstValidSartDate(new Date(), this.gracePeriod);
    this.searchForm = this.formBuilder.group({
      location: ['', Validators.required],
      PickUpDate: [this.minPickUpDate, Validators.required],
      //PickUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(new RegExp('[0-9]?[0-9]:([0-9]$)([0-9]$)am|pm'))])],
      PickUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(
        new RegExp('(0[1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|([1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|(1[0-2]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))'))])],
      dropUpDate: [dateOfTmw, Validators.required],
      //dropUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern('[0-9]?[0-9]:[0-9][0-9]am|pm')])],
      dropUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(
        new RegExp('(0[1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|([1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|(1[0-2]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))'))])],
      datepicker: [new Date(), Validators.required],
      eazyRent: [false],
    });

    let scopeMinTime;
    this.searchService.reservationSettingModel.subscribe(res => {
      if (res != null) {
        let easyRentObj = res.eazyRentSettings;
        if (easyRentObj != null && easyRentObj.enableEazyrent) {
          this.easyRentSection = true;
        }
        //this.gracePeriod = res.bookingGracePeriodSettings.bookingGracePeriodInHours;
        this.gracePeriod = 0;
        this.minTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod);

        //this.minDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html
        //Due to Error in Jquery cannot see global variable this.
        let scopeMinDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html
        this.searchForm.controls.PickUpTime.setValue(this.minTime);
        this.searchForm.controls.dropUpTime.setValue(this.minTime);
        scopeMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,
        $(document).ready(function () {
          //Initilize the Time Picker for pick up and drop off
          $('#pickUpTime').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });
          //There is no min time in drop off , because its a day after
          $('#dropUpTime').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });


        });
        this.minDropOffDate = new Date();
        this.minDropOffDate.setDate(new Date().getDate());
        //this.searchForm.controls.dropUpDate.setValue(this.minDropOffDate);


        this.minPickUpDate = this.searchService.getFirstValidSartDate(new Date(), this.gracePeriod);
        this.searchForm.controls.PickUpDate.setValue(this.minPickUpDate);
        let afterOneDay = new Date();
        afterOneDay.setDate(this.minPickUpDate.getDate() + 1);
        this.minDropOffDate = this.minPickUpDate;
        this.searchForm.controls.dropUpDate.setValue(afterOneDay);
      }


    })

    this.authService.loggedInCustomer.subscribe(res => {
      this.customer = res;
    })



    navigator.geolocation.getCurrentPosition(position => {
      this.currentLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      this.searchService.geocode(position.coords.latitude, position.coords.longitude)
        .subscribe(res => {



          let locatons = JSON.parse(JSON.stringify(res));
          this.address = locatons.results[0];

          this.currentLocationFormatedAdress=locatons.results[0].formatted_address;
          this.searchForm.controls.location.setValue(locatons.results[0].formatted_address);
        });

    });


    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default:
        this._adapter.setLocale('en-US');
        break;
    }



  }
  ngAfterViewInit() {
    this.loadingService.hide();

    //Attach onChange Event
    $('#pickUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.PickUpTime.setValue($(e.target).val());
      //Check IF PickUp Time is greater than DropOff
      //this.validateDropOffTimeBasedOnPickUp($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
    });
    $('#dropUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.dropUpTime.setValue($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
    });

  }

  /** Validate DropOffTime Based on PickUpTime*/
  validateDropOffTimeBasedOnPickUp(pickUpTime: string) {

    let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
    let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);

    //IF They are on the same day, then we need to check
    //If the picktime greater than DropOff
    if (pickUpDate.getDate() == dropOffDate.getDate()) {
      let dropOffTime = this.searchForm.controls.dropUpTime.value;
      let compareResult = this.searchSectionService.comparePickUpAndDropOffTime(pickUpTime, dropOffTime);
      //If PickUp Is Greater than dropOff , then we will validate dropOff
      if (compareResult == 1) {

        this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
    }

  }


  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  onSubmit() {

    /*     this._notifications.success(
          'Some Title',
          'Some Content',
          {
              timeOut: 5000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 10
          }
      ) */
    this.submitted = true;



    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    if ( this.searchForm.controls["PickUpTime"].value >  this.searchForm.controls["dropUpTime"].value && this.searchForm.controls["PickUpDate"].value == this.searchForm.controls["dropUpDate"].value ){

      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res =>{
        this._notifications.warn( "<span>"+res+"</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })
      return;
    }

    //#region  BUG 3393

    /*
    [web- search result ] the system should not display any result in case  the current date < date +booking grace period
    */



    let StartDate = new Date(this.searchForm.value['PickUpDate']);
    let StartTimeString = this.searchForm.controls["PickUpTime"].value;

    let EndDate = new Date(this.searchForm.value['dropUpDate']);
    let EndTimeString = this.searchForm.controls["dropUpTime"].value;



    if (!this.searchService.validateDropOffVSPickUp(StartDate, StartTimeString, EndDate, EndTimeString)) {
      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
        this._notifications.warn("<span>" + res + "</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })
      return;
    }

    //#endregion

    //Validate pickup Time
    /*  if (!this.searchService.validateTime(this.searchForm.value['PickUpTime'], this.minTime)) {
       this.searchForm.controls['PickUpTime']?.setErrors({ 'Invalid': true });
       return;
     } */

    this.searchForm.value['currentLocation'] = this.currentLocation;
    var searchModel: VehicleReservationSearchParm = {
      StartDateString: this._dateFormatPipe.transform(this.searchForm.value['PickUpDate']),
      StartDate: this.searchForm.value['PickUpDate'],
      StartTimeString: this.searchForm.value['PickUpTime'],
      EndDateString: this._dateFormatPipe.transform(this.searchForm.value['dropUpDate']),
      EndDate: this.searchForm.value['dropUpDate'],
      EndTimeString: this.searchForm.value['dropUpTime'],
      Latitude: this.currentLocation.lat,
      Longitude: this.currentLocation.lng,
      FormatedLocation: this.address.formatted_address,
      PageSize: this.searchService.pageSize,
      PageNumber: 1,

      //AgencyID:'039c11de-5c2d-4e36-a7d0-30124bcfb040'//Tmp delete it , only for testing.

    };
    if (this.customer != null) {
      searchModel.CustomerID = this.customer.customerID;
    }
    if (this.currentLocation.lng == 0 && this.currentLocation.lat == 0) {

      this.translate.get('Pleaseselectfromlocationdropdownlist').subscribe(res => {
        this._notifications.warn("<span>" + res + "</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })

    }
    else {
      this.searchService.updateSearchModel(searchModel);
      //this.router.navigate(['/searchByLocation', { search: JSON.stringify(searchModel) }]);
      this.router.navigate(['/searchByLocation']);
    }





  }
  validateDropOffVSPickUp(): boolean {


    let isValid = true;
    let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);
    let dropOffTime = this.searchForm.controls.dropUpTime.value;

    let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
    let pickUpTime = this.searchForm.controls.PickUpTime.value;

    if (dropOffDate.getDate() == pickUpDate.getDate()) {

      //If dropOff equal or greaer than pickup
      if (this.searchService.compareTwoTime(pickUpDate, pickUpTime, dropOffDate, dropOffTime) <= 0) {
        isValid = false;
      }
    }

    return isValid;
  }

  // onReset() {
  //     this.submitted = false;
  //     this.searchForm.reset();
  // }
  public handleAddressChange(address: Address) {
    // Do some stuff

    this.currentLocation = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
    };
   // this.address = address;




  }

  addEvent(mode: number, type: string, event: MatDatepickerInputEvent<Date>) {




    //PickUp Date
    if (mode == 1) {
      let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);
      this.minDropOffDate = new Date(event.value);
      if (new Date(event.value).getDate() == new Date().getDate() && new Date(event.value).getDate() == dropOffDate.getDate()) {


        this.searchForm.controls.PickUpTime.setValue(this.minTime);

        this.searchForm.controls.dropUpTime.setValue(this.minDroppOffTime);
      }
      else if (new Date(event.value).getDate() == new Date().getDate()) {
        //$('#pickUpTime').timepicker('option', 'minTime', this.minTime);
        this.searchForm.controls.PickUpTime.setValue(this.minTime);
      }
      else {
        if (new Date(event.value).getDate() == dropOffDate.getDate()) {

          let pickUpTime = this.searchForm.controls.PickUpTime.value;

          this.searchForm.controls.dropUpTime.setValue(pickUpTime);
        }
        //IF PickUp Date Greter than drop OFF
        else if (new Date(event.value) > dropOffDate) {
          this.searchForm.controls.dropUpDate.setValue(new Date(event.value));
          let pickUpTime = this.searchForm.controls.PickUpTime.value;
          let dropUpTime = this.searchForm.controls.dropUpTime.value;
          if (!this.searchService.validateTime(dropUpTime, pickUpTime)) {

            this.searchForm.controls.dropUpTime.setValue(pickUpTime);
          }
        }
        else {

        }
      }

    }
    //Drop Off Date
    else if (mode == 2) {
      let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
      if (new Date(event.value).getDate() == pickUpDate.getDate()) {
        let pickUpTime = this.searchForm.controls.PickUpTime.value;
        /*   $('#dropUpTime').timepicker('option', 'minTime', pickUpTime); */
        //this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
      else {

      }
    }




  }

  onAutocompleteSelected(result: PlaceResult) {

    
    this.currentLocation = {
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
    };
    this.searchForm.controls.location.setValue(result.formatted_address);
    this.address = result;
  }

  onLocationSelected(location: LocationAutocomplete) {


  }


}
